import {
	ApiCategoryReport,
	ApiReportDocument,
	ApiReportDocumentTemplate,
	ApiReportDocumentUpdateBody,
} from '../api-types/report-document.api';
import {
	CategoryReport,
	ReportDocument,
	ReportDocumentTemplate,
	ReportDocumentUpdateBody,
} from '../app-types/report-document.app';
import { transformApiDocumentFilesToAppDocumentFiles } from './document.transform';

export function transformApiCategoryReportToCategoryReport(input: ApiCategoryReport): CategoryReport {
	return {
		id: input.id,
		description: input.description,
	};
}

export function transformApiReportDocumentTemplateToReportDocumentTemplate(
	input: ApiReportDocumentTemplate,
): ReportDocumentTemplate {
	return {
		id: input.id,
		htmlContent: input.htmlContent,
		validForTypeOfCareId: input.validForTypeOfCareId,
		category: input.categoryReport ? transformApiCategoryReportToCategoryReport(input.categoryReport) : undefined,
	};
}

export function transformApiReportDocumentTemplatesToReportDocumentTemplates(
	inputs: ApiReportDocumentTemplate[],
): ReportDocumentTemplate[] {
	return inputs.map(transformApiReportDocumentTemplateToReportDocumentTemplate);
}

export function transformApiReportDocumentToReportDocument(input: ApiReportDocument): ReportDocument {
	return {
		id: input.id,
		htmlContent: input.htmlContent,
		isFinal: input.isFinal,
		isDraft: input.isDraft,
		canBeSubmitted: input.reportCanBeSubmitted,
		createdAt: new Date(input.createdAt),
		updatedAt: input.lastUpdatedAt ? new Date(input.lastUpdatedAt) : undefined,
		template: input.reportDocumentTemplate
			? transformApiReportDocumentTemplateToReportDocumentTemplate(input.reportDocumentTemplate)
			: undefined,
		documents: transformApiDocumentFilesToAppDocumentFiles(input.documents ?? []),
		categoryReport: transformApiCategoryReportToCategoryReport(input.categoryReport),
	};
}

export function transformApiReportDocumentsToReportDocuments(inputs: ApiReportDocument[]): ReportDocument[] {
	return inputs.map(transformApiReportDocumentToReportDocument);
}

export function transformReportUpdateBodyToApiReportUpdateBody(
	input: ReportDocumentUpdateBody,
): ApiReportDocumentUpdateBody {
	return {
		htmlContent: input.htmlContent,
		isFinal: input.isFinal,
		isDraft: input.isDraft,
		reportDocumentTemplateId: Number(input.reportDocumentTemplateId),
	};
}
